import {
  Box,
  Heading,
  HStack,
  IconButton,
  Slide,
  Tooltip,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { ModalConfirm } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { cloneElement, Fragment } from "react";

export const Dialogs = observer(function Dialogs() {
  const { UIStore } = useStore();

  return (
    <div>
      {[...UIStore.dialogs.modalStack].map(([id, modal]) => (
        <Fragment key={id}>{cloneElement(modal, { modalId: id })}</Fragment>
      ))}
      <Slide
        direction="bottom"
        in={UIStore.dialogs.areModalsMinimized}
        style={{
          zIndex: "1000",
        }}
      >
        <HStack justifyContent="flex-end" pr="24" spacing="2">
          {[...UIStore.dialogs.minimizedModals]
            .toReversed()
            .map(([id, options]) => (
              <Box
                key={`minimized-modal-${id}`}
                px="4"
                py="2"
                bg="white"
                border="1px"
                borderColor="gray.200"
                shadow="2xl"
                roundedTop="md"
              >
                <HStack align="center" spacing="4">
                  <Heading size="xs">{options.title}</Heading>
                  <HStack spacing="0">
                    <Tooltip label={t`Maximize`} placement="top">
                      <IconButton
                        aria-label={t`Maximize`}
                        colorScheme="grey"
                        icon={<Icon name="maximize-01" />}
                        onClick={options.onMaximize}
                        size="sm"
                        variant="ghost"
                      />
                    </Tooltip>
                    <Tooltip label={t`Close`} placement="top">
                      <IconButton
                        aria-label={t`Close`}
                        colorScheme="grey"
                        icon={<Icon name="x-close" />}
                        onClick={() => UIStore.dialogs.closeModal(id)}
                        size="sm"
                        variant="ghost"
                      />
                    </Tooltip>
                  </HStack>
                </HStack>
              </Box>
            ))}
        </HStack>
      </Slide>
      <ModalConfirm
        destructive
        isOpen={UIStore.dialogs.warningModalDisclosure.isOpen}
        onClose={UIStore.dialogs.warningModalDisclosure.onClose}
        onConfirm={UIStore.dialogs.handleWarningModalConfirm}
        message={
          <Trans>
            Cannot open multiple instances of the same modal, by opening new one
            you will lose your changes. Are you sure you want to continue?
          </Trans>
        }
        confirmBtnTitle={t`Discard and continue`}
      />
    </div>
  );
});
